var BEES = require('serialisers/byte-encoded-enum-serialiser');
var Codec = require('io/codec');

var Priority = require('../../../features/messages').Priority;

var serialiser = {
    read : function(input) {
        var priority = BEES.read(input, Priority);
        var headers = Codec.readCollection(input, Codec.readString);

        return {
            priority : priority,
            headers : headers
        };
    },
    write : function(output, req) {
        BEES.write(output, req.priority);
        Codec.writeCollection(output, req.headers, Codec.writeString);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/send/send-options-serialiser.js
// module id = 196
// module chunks = 1